import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import { getPayerFiltersAction } from 'src/redux/actions/documentBundleActions';

export interface PayerOption {
  value: string;
  label: string;
  available: boolean;
}

export function usePayerOptions(dateFrom: Date, dateTo: Date) {
  const dispatch = useDispatch();
  const { response, loading } = useSelector((state: any) => state.getPayerFiltersReducer);

  useEffect(() => {
    dispatch(
      getPayerFiltersAction({
        date_from: format(dateFrom, 'yyyy-MM-dd'),
        date_to: format(dateTo, 'yyyy-MM-dd'),
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateFrom, dateTo]);

  const payerTypes: any[] = response?.payerTypes ?? [];

  const payerOptions: PayerOption[] = payerTypes.map((pt: any) => ({
    value: pt.type,
    label: pt.label,
    available: pt.available,
  }));

  const payerNames: Record<string, string[]> = {};
  payerTypes.forEach((pt: any) => {
    payerNames[pt.type] = pt.payerNames ?? [];
  });

  return { payerOptions, payerNames, loading };
}
